import React from "react"
import Select from "react-select"
import _ from "lodash"
import {
    Card,
    CardBody,
    Row,
    Col,
} from "reactstrap"

const StatusFilter = ({ onFilterChange, title , stateName, options}) => {

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col>
                        <p className="text-muted">{"Filter by "+title}   </p>
                        <Select
                            isClearable
                            className="react-select primary mt-n3"
                            classNamePrefix="react-select"
                            placeholder={"All "+ title}
                            onChange={value => onFilterChange({ [stateName]: value })}
                            options={options}
                        />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default StatusFilter